<template>
  <div v-loading="courseAllLoading" class="course-all-box">
    <div style="margin-bottom:20px;display: flex;justify-content: space-between;padding-right:64px;">
      <div>
        <el-button class="action-item" type="primary" icon="el-icon-share" style="margin-right:30px;" @click="setPlan()">排课计划</el-button>
        <!-- 门店：
        <el-select
          v-model="siteId"
          filterable
          remote
          reserve-keyword
          placeholder="请选择门店"
          :remote-method="getSiteList"
          :loading="selectloading"
          clearable
        >
          <el-option
            v-for="item in siteList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select> -->
      </div>
      <el-button-group>
        <el-button type="primary" icon="el-icon-arrow-left" @click="changeWeek(-1)">上一周</el-button>
        <el-button type="primary" @click="changeWeek(1)">下一周<i class="el-icon-arrow-right el-icon--right"></i></el-button>
        <el-button v-if="week !== 0" type="primary" icon="el-icon-refresh-left" @click="changeWeek(0)">回到本周</el-button>
      </el-button-group>
    </div>
    <el-table :key="key2" :data="tableData" border style="width:95%;height:684px;overflow-y: scroll;" :cell-style="cellStyle">
      <el-table-column v-for="(items,index) in dates" :key="index" :field="items.field" align="center" style="width:12.5%">
        <template v-if="index === 0" slot="header">
          <div class="header-div">
            <div class="header-col1">时间段</div>
            <div class="header-col2">日期</div>
            <div class="header-line"></div>
          </div>
        </template>
        <template v-else slot="header">
          <div>{{ items.week }}</div>
          <div>{{ items.date }}</div>
        </template>
        <template slot-scope="scope">
          <div v-if="items.field === 'time'" class="course-all-list">
            {{ scope.row[items.field] }}
          </div>
          <div v-else class="course-all-list">
            <span v-if="scope.row[items.field].site&&scope.row[items.field].site.name" style="color:#1890ff">{{ scope.row[items.field].site.name }}</span>
            <!-- <el-button type="text" :disabled="scope.row[items.field].book==0">预约：{{ scope.row[items.field].book }}人</el-button> -->

            <el-popover placement="right" width="526" trigger="click" @show="bookShowData(scope.row.time,items.field,items.date)">
              <el-table v-if="bookShow == scope.row.time+'_'+items.field" v-loading="bookLoading" :data="bookData" height="383px">
                <el-table-column width="80" property="avatar" align="center" label="用户头像">
                  <template slot-scope="scope2">
                    <el-avatar :size="40" :src="base_url+scope2.row.avatar" @error="true">
                      <img :src="base_url+'static/image/default_avatar.png'">
                    </el-avatar>
                  </template>
                </el-table-column>
                <el-table-column property="nickname" align="center" label="用户昵称"></el-table-column>
                <el-table-column width="120" property="phone" align="center" label="用户手机号"></el-table-column>
              </el-table>
              <el-button slot="reference" type="text" :disabled="scope.row[items.field].book==0">预约：{{ scope.row[items.field].book }}人</el-button>
            </el-popover>

          </div>
        </template>
      </el-table-column>

    </el-table>
    <!--排课计划-->
    <el-dialog title="排课计划" :visible.sync="dialogDetailsVisible" width="1200px" top="10vh">
      <plan v-if="dialogDetailsVisible" ref="plan" :coach-id="coachId"></plan>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogDetailsVisible = false">取 消</el-button>
        <el-button type="primary" @click="courseArrangement">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api/lesson/lesson' // 和数据交互相关写在api 方便复用
import site from '@/api/site/site'
import Plan from './plan'
export default {
  name: 'LessonCourse',
  // 列绑定格式化器
  filters: {
  },
  components: { Plan },
  props: {
    coachId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      base_url: process.env.VUE_APP_BASE_API,
      dialogDetailsVisible: false,
      api,
      dates: [],
      key2: 0,
      week: 0,
      tableData: [],
      times: [],
      courseAllLoading: false,
      siteList: [],
      selectloading: false,
      siteId: '',
      bookLoading: false,
      bookShow: '',
      bookData: []
    }
  },
  watch: {
    coachId() {
      this.getDateOne()
    },
    siteId(val) {
      this.getDateAll()
    }
  },
  beforeMount() {
    this.getdates()
  },
  mounted() {
    this.getDateOne()
    this.getSiteList('')
  },
  methods: {
    getSiteList(val) {
      this.selectloading = true
      site.Query({
        name: val, page: 1, limit: 10, sort: 'order_no', order: 'asc', coach_id: this.coachId
      }).then(res => {
        this.siteList = res.data.items
        this.selectloading = false
      })
    },
    setPlan() {
      this.dialogDetailsVisible = true
    },
    bookShowData(time, field, date) {
      this.bookShow = time + '_' + field
      this.bookLoading = true
      api.BookList({
        time: time,
        field: field,
        date: date,
        coach_id: this.coachId
      }).then(res => {
        this.bookData = res.data
        this.bookLoading = false
      })
    },
    getdates() {
      const now = new Date()
      const week = now.getDay()
      const weekLabels = ['一', '二', '三', '四', '五', '六', '日']
      const dates = [
        {
          field: 'time',
          week: '',
          date: ''
        }
      ]
      for (let i = 1; i <= 7; i++) {
        const date = new Date(now.getTime() - 24 * 60 * 60 * 1000 * (week - i - (this.week * 7)))
        dates.push({
          field: 'week' + i,
          week: '周' + weekLabels[i - 1],
          date: date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
        })
      }
      this.$nextTick(() => {
        this.dates = dates
        this.key2 = Math.random()
      })
    },
    getDateOne() {
      this.courseAllLoading = true
      api.DateOne({
        week: this.week,
        coach_id: this.coachId
      }).then(res => {
        this.courseAllLoading = false
        this.tableData = res.data
      }).catch(() => { this.courseAllLoading = false })
    },
    changeWeek(num) {
      if (num === 0) {
        this.week = 0
      } else {
        this.week = this.week + num
      }
      this.getDateOne()
      this.getdates()
    },
    courseArrangement() {
      const response = this.$refs.plan.saveData()
      api.SavePlan(response).then(res => {
        this.$message({
          message: '保存成功',
          type: 'success'
        })
        this.dialogDetailsVisible = false
      })
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      // if (columnIndex > 0) {
      //   if (row['week' + columnIndex].site && row['week' + columnIndex].site.name && row['week' + columnIndex].book > 0) {
      //     return 'background:#000;color:#fff;'
      //   } else if (row['week' + columnIndex].site && row['week' + columnIndex].site.name) {
      //     return 'background:e0ffff;color:#fff;'
      //   } else if (row['week' + columnIndex].book > 0) {
      //     return 'background:rgb(225, 243, 216);color:white;'
      //   }
      // }
    }
  }
}
</script>
<style>
/deep/ .column-custom {
	padding: 0px !important;
}

 /deep/ .el-table--border .el-table__cell:first-child .cell {
	padding: 0 !important;
}
/* .el-dialog__body{
  padding-top: 0px !important;
} */
.header-div {
	height: 50px;
	position: relative;
}
.header-col1 {
	position: absolute;
	left: 0;
	bottom: 0;
}
.header-col2 {
	position: absolute;
	right: 0;
	top: 0;
}
.header-line {
	padding-left: 0;
	width: 1px;
	height: 150px;
	transform: rotate(-67deg); /*这里需要自己调整，根据线的位置*/
	-webkit-transform-origin: top;
	transform-origin: top;
	background-color: #fff;
  border-left:1px solid #e5e5e5;
}
.el-table::before{
  height:0 !important;
}

.course-all-box{
  width: 1260px;
  margin:20px auto;
  height:740px;
  /* overflow-y: scroll; */
}
.is-selected {
    color: #1989FA;
  }
  .course-all-list{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

</style>
